import { NgModule } from '@angular/core';
import { TextmeComponent } from './textme.component';



@NgModule({
  declarations: [TextmeComponent],
  imports: [
  ],
  exports: [TextmeComponent]
})
export class TextmeModule { }
